import { Box, Button, Paper, Table, TableBody, TableCell, TableContainer, TableRow, Typography, useTheme } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useQuizAndQuestionbankStore } from '../../../store/quizandquestionbank.store'
import noQuizImage from '../../../assets/no-quiz.svg'
import { observer } from 'mobx-react'
import CreateQuizDialog from '../../../components/exams-components/quiz-questionbank/CreateQuizDialog'
import { Icons, formatDate } from '../../../utils/utilities'
import { Link, useParams } from 'react-router-dom'
import DataLoadingSpinner from '../../../components/common/DataLoadingSpinner'
import TableHeader from '../../../components/common/TableHeader'
import api from '../../../service/api'
import { useUserStore } from '../../../store/user.store'
import { toast } from 'react-toastify'

const columns = [
    { name: "TITLE", align: "left", minWidth: "180px", padding: "10px 20px 10px 40px" },
    { name: "CREATED ON", minWidth: "150px", align: "left" },
    { name: "SUBJECT", align: "left", minWidth: "200px" },
    { name: "TOPIC COUNT", minWidth: "150px", align: "center" },
    { name: "QUESTIONS COUNT", minWidth: "170px", align: "center", padding: "10px 40px 10px 20px" },
]


const Quizzes = observer( ( { fromComponent = 'subject' } ) => {

    const [loading, setLoading] = useState( true )
    const [createDialogState, setCreateDialogState] = useState( false )

    const QuizStore = useQuizAndQuestionbankStore()
    const UserStore = useUserStore()

    const { palette, table, border } = useTheme()

    const { subject_code } = useParams()


    const retrieveOldQuizzes = async () => {
        try {
            await api.quiz.retrieveLegacyAliveQuizzes()
            setLoading( true )
            await UserStore.fetchUser()
            await QuizStore.fetchQuizes()
            setLoading( false )
        } catch ( err ) {
            toast( err?.response?.data?.message || "Something went wrong while retriving legacy quizzes!" )
        }
    }

    useEffect( () => {
        const getData = async () => {
            if ( QuizStore.getErrors.quizzes === true )
                await QuizStore.fetchQuizes()
            setLoading( false )
        }
        getData()
    }, [QuizStore] )

    return (
        <Box padding="20px" flexGrow={1} display="flex" flexDirection="column" overflow="auto">
            {createDialogState && <CreateQuizDialog fromComponent={fromComponent} state={createDialogState} setState={setCreateDialogState} />}
            <Paper sx={{ display: "flex", flexGrow: 1, flexDirection: "column", overflow: "hidden", minHeight: "450px" }} elevation={0}>
                <Box display="flex" flexWrap="wrap" justifyContent="space-between" borderBottom={"1px solid #d3d3d3"} alignItems="center" gap="10px" padding={"20px"} >
                    <Box>
                        <Typography variant="h5">Quizzes</Typography>
                        {<Typography variant="subtitle2">Manage your quizzes here</Typography>}
                    </Box>
                    <Box display="flex" gap="10px" flexWrap="qrap" alignItems="center">
                        <Button onClick={() => setCreateDialogState( true )} variant="contained" disableElevation startIcon={Icons.default.AddIcon} sx={{ textTransform: "capitalize" }} color="primary">
                            Create Quiz
                        </Button>
                    </Box>
                </Box>
                {!loading && QuizStore.getQuizes.filter( q => !subject_code || q.subject.subject_code === subject_code ).length > 0 && <Box margin="20px" border={border[1]} borderRadius="5px" flexGrow={1} display="flex" flexDirection='column' overflow="auto" >
                    <TableContainer className='custom-scrollbar' sx={{ height: "100%", flexGrow: 1, overflow: "auto", borderRadius: "5px" }}>
                        <Table stickyHeader>
                            <TableHeader columns={columns} />
                            <TableBody>
                                {QuizStore.getQuizes.filter( q => !subject_code || q.subject.subject_code === subject_code ).map( ( quiz, index ) => (
                                    <TableRow sx={{
                                        position: "relative",
                                        '&::after': {
                                            content: `''`,
                                            background: "#d3d3d3",
                                            position: "absolute",
                                            height: "1px",
                                            width: "calc(100% - 40px)",
                                            bottom: 0,
                                            left: "50%",
                                            transform: "translateX(-50%)"
                                        },

                                        "&:hover": {
                                            background: palette.rowHover
                                        },
                                        cursor: "pointer"
                                    }} key={quiz.id}>
                                        <TableCell sx={{ border: "none", color: table.color, padding: "0" }} align={columns[0].align || 'left'} >
                                            <Link className='default-link' to={`${quiz.id}`}>
                                                <Box padding={columns[0].padding || "10px 40px"} display="flex" alignItems="center" gap="10px">
                                                    {/* <Box width="20px" height="20px">
                                                        <img width="100%" height="100%" style={{ objectFit: "contain" }} src={QuizStore.getDefaultThumbs[`default-${( index % 3 ) + 1}`]} alt="Thumb" />
                                                    </Box> */}
                                                    <Typography title={quiz.title} fontSize="inherit" maxWidth={columns[0].minWidth} noWrap>
                                                        <strong>
                                                            {quiz.title}
                                                        </strong>
                                                    </Typography>
                                                </Box>
                                            </Link>
                                        </TableCell>
                                        <TableCell sx={{ border: "none", color: table.color, padding: "0" }}  >
                                            <Link className='default-link' to={`${quiz.id}`}>
                                                <Box padding="10px 20px">
                                                    <strong>
                                                        {formatDate( quiz.created_at )}
                                                    </strong>
                                                </Box>
                                            </Link>
                                        </TableCell>
                                        <TableCell sx={{ border: "none", color: table.color, padding: "0" }}  >
                                            <Link className='default-link' to={`${quiz.id}`}>
                                                <Box sx={{ textTransform: "capitalize" }} padding="10px 20px">
                                                    <strong>
                                                        {quiz.subject.subject_name}
                                                    </strong>
                                                </Box>
                                            </Link>
                                        </TableCell>
                                        <TableCell sx={{ border: "none", color: table.color, padding: "0" }} align={columns[3].align || 'left'} >
                                            <Link className='default-link' to={`${quiz.id}`}>
                                                <Box padding="10px 20px">
                                                    <strong>
                                                        {quiz?.question_bank_topics?.length}
                                                    </strong>
                                                </Box>
                                            </Link>
                                        </TableCell>
                                        <TableCell sx={{ border: "none", color: table.color, padding: "0" }} align={columns[4].align || 'left'} >
                                            <Link className='default-link' to={`${quiz.id}`}>
                                                <Box padding={columns[4].padding || "10px 20px"}>
                                                    <strong>
                                                        {quiz.number_of_question}
                                                    </strong>
                                                </Box>
                                            </Link>
                                        </TableCell>
                                    </TableRow>
                                ) )}
                            </TableBody>
                        </Table>
                    </TableContainer>

                </Box>}
                {!loading && QuizStore.getQuizes.filter( q => !subject_code || q.subject.subject_code === subject_code ).length === 0 && <Box bgcolor={palette.contentBg} flexGrow={1} display="flex" flexDirection="column" alignItems="center" padding="20px" justifyContent="center" gap="20px">
                    <img src={noQuizImage} width="150px" alt="No quizes" />
                    <Typography variant="subtitle2">You haven't created any quizes!</Typography>
                    <Button onClick={() => setCreateDialogState( true )} startIcon={Icons.default.AddIcon} variant='outlined' color="greyed"  >Create one</Button>
                </Box>}
                {loading && <DataLoadingSpinner waitingMessage="Loading quizes..." />}
            </Paper>
        </Box>
    )
} )

export default Quizzes
